<template>
  <div class="container">
    <div class="header-box">
      <home-top></home-top>
    </div>
    <div class="content-box">
      <!-- 轮播 -->
      <div class="content-swiper">
        <swiper class="sAstyle" :swiperSetting="swiperSetting" :slideArray="homeSlideArray"></swiper>
        <!-- 遮罩层 -->
        <div class="rotationMask">
          <span>{{ notice }}</span>
        </div>
        <!-- 文字 -->
        <div class="suspensionFrame">
          <div class="suspensionChild">
            <div class="advertingStyle">
              <div>
                <span>{{ adverting }}</span>
              </div>
              <div class="p-marginLeft40">
                <span>{{ advertingOther }}</span>
              </div>
            </div>
            <div class="adverting1Style">
              <span>{{ adverting1 }}</span>
            </div>
            <div class="adverting2Style">
              <div class="p-marginLeft30">
                <span>{{ adverting2 }}</span>
              </div>
              <div class="p-marginLeft30">
                <span>{{ adverting3 }}</span>
              </div>
              <div class="p-marginLeft30">
                <span>{{ adverting4 }}</span>
              </div>
              <div class="p-marginLeft30">
                <span>{{ adverting5 }}</span>
              </div>
            </div>
          </div>
          <div class="graphical">
            <div class="circle"></div>
            <div class="line"></div>
            <div class="circle"></div>
            <div class="line"></div>
            <div class="circle"></div>
            <div class="line"></div>
            <div class="circle"></div>
          </div>
        </div>
      </div>
      <!-- 金刚区 -->
      <div class="abilityPiece">
        <div class="firstFrame">
          <!-- <div class="firstFrame-left">
            <imgAndText :imgHeight="exhibit1.imgHeightRight" :picImg="exhibit1.leftPicImg">
              <div class="firstFrame-leftFrame">
                <div class="firstFrame-leftTitle">
                  <span @click="img1Click">{{ exhibit1.titleRemark || "暂无内容" }}</span>
                  <div class="firstFrame-border"></div>
                </div>
                <div class="firstFrame-leftText">
                  <p>{{ exhibit1.titleContent || "" }}</p>
                </div>
              </div>
            </imgAndText>
          </div> -->
		  <div class="firstFrame-right">
		    <imgAndText :imgHeight="exhibit1.imgHeightRight" :picImg="exhibit1.leftPicImg">
		      <div class="firstFrame-rightFrame">
		        <div class="firstFrame-rightTitle">
		          <span @click="img1Click">{{ exhibit1.titleRemark || "暂无内容" }}</span>
		          <div class="firstFrame-border"></div>
		        </div>
		        <div class="firstFrame-rightText">
		          <p>{{ exhibit1.titleContent || "" }}</p>
		        </div>
		      </div>
		    </imgAndText>
		  </div>
		  <div class="firstFrame-right">
		    <imgAndText :imgHeight="exhibit2.imgHeight" :picImg="exhibit2.rightPicImg">
		      <div class="firstFrame-rightFrame">
		        <div class="firstFrame-rightTitle">
		          <span>{{ exhibit2.titleRemark || "暂无内容" }}</span>
		          <div class="firstFrame-border"></div>
		        </div>
		        <div class="firstFrame-rightText">
		          <p>{{ exhibit2.titleContent || "" }}</p>
		        </div>
		      </div>
		    </imgAndText>
		  </div>
          <div class="firstFrame-right">
            <imgAndText :imgHeight="exhibit4.imgHeight" :picImg="exhibit4.rightPicImg">
              <div class="firstFrame-rightFrame">
                <div class="firstFrame-rightTitle">
                  <span>{{ exhibit4.titleRemark || "暂无内容" }}</span>
                  <div class="firstFrame-border"></div>
                </div>
                <div class="firstFrame-rightText">
                  <p>{{ exhibit4.titleContent || "" }}</p>
                </div>
              </div>
            </imgAndText>
          </div>
        </div>
        <div class="secendFrame">
          <imgAndText :imgHeight="exhibit3.bigImgHeight" :picImg="exhibit3.bigPicImg">
            <div class="secendFrameText">
              <span>{{ exhibit3.titleRemark || "暂无内容" }}</span>
            </div>
          </imgAndText>
        </div>
      </div>
      <div class="bigFrame">
        <img :src="bigAdvertise" class="imgStyle" />
      </div>
    </div>
    <div class="footer-box">
      <home-bottom></home-bottom>
    </div>
  </div>
</template>

<script>
import swiper from "../assembly/swiper.vue"
import homeTop from '../assembly/homeTop.vue'
import homeBottom from '../assembly/homeBottom.vue'
import imgAndText from "../common/imgAndText"
//
import { getHome } from "../api/home.js"
export default {
  data() {
    return {
      swiperSetting: {
        delay: 3000
      },
      notice: "公司公告: 公司利用科技+大数据赋能，实现自身高速发展及核心竞争力，当前投资及管理的个贷不良资产规模近130亿元",
      adverting: "道法自然 ",
      advertingOther: " 依法则通",
      adverting1: "互联网金融法律服务生态链平台",
      adverting2: "专业化",
      adverting3: "精细化",
      adverting4: "特色化",
      adverting5: "科技创新",
      //
      currentArray: {},
      //
      exhibit1: {
        imgHeightRight: "35",
        leftPicImg: ""
      },
      exhibit2: {
        imgHeight: "35",
        rightPicImg: ""
      },
      exhibit3: {
        bigImgHeight: "55",
        bigPicImg: ""
      },
      
      exhibit4: {
        imgHeight: "35",
        rightPicImg: ""
      },
	  
      bigAdvertise: "",
      networkArray: [],
      homeSlideArray: []
    }
  },
  components: {
    homeTop,
    swiper,
    homeBottom,
    imgAndText
  },
  created() {
    // 首页
    let modelId = 0;
    getHome({ modelId }).then((res) => {
      console.log(res)
      if (res.code == 200 && res.data.length > 0) {
        this.networkArray = res.data
        this.getDetails()
      }
    })
  },
  methods: {
    getDetails() {
      // 首页轮播图
      this.networkArray.forEach((item) => {
        switch (item.titleSort) {
          case 0:
            return this.currentArray = item
          case 1:
            return this.exhibit1 = {
              ...this.exhibit1,
              ...item
            }
          case 2:
            return this.exhibit2 = {
              ...this.exhibit2,
              ...item
            }
          case 3:
            return this.exhibit3 = {
              ...this.exhibit3,
              ...item
            }
			case 5:
			  return this.exhibit4 = {
				...this.exhibit4,
				...item
			  }
          case 4:
            return this.bigAdvertise = item.fileList[0].filePath
        }
      })
      // 轮播图
      this.currentArray.fileList.forEach((item) => {
        this.homeSlideArray.push({
          url: item.filePath
        })
      })
      // 展示图1
      this.exhibit1.leftPicImg = this.exhibit1.fileList[0].filePath
      // 展示图2
      this.exhibit2.rightPicImg = this.exhibit2.fileList[0].filePath
      // 展示图3
      this.exhibit3.bigPicImg = this.exhibit3.fileList[0].filePath
	  
	  this.exhibit4.rightPicImg = this.exhibit4.fileList[0].filePath
      // 广告图
    },
		img1Click() {
			window.location.href = 'https://www.yindeng.com.cn/Home/fggf/cn/qgx/20211101/1242473.shtml';
		}
  }
}
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: rgb(241, 241, 241);
}

.header-box {
  height: 85px;
  width: 100%;
}

.content-box {
  box-sizing: border-box;
  width: 100%;

  // 轮播区
  .content-swiper {
    height: 92vh;
    width: 100%;

    .rotationMask {
      top: 94vh;
      height: 6rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      z-index: 3;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      font-size: 1.5rem;
    }

    .suspensionFrame {
      color: white;
      z-index: 2;
      position: absolute;
      top: 30vh;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      pointer-events: none;

      .suspensionChild {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .advertingStyle {
        display: flex;
        font-size: 5rem;
        letter-spacing: 3rem;
      }

      .adverting1Style {
        margin-top: 30px;
        letter-spacing: 2rem;
        font-size: 8rem;
      }

      .adverting2Style {
        margin-top: 30px;
        display: flex;
        font-size: 3rem;
        letter-spacing: 1rem;
      }

      .graphical {
        margin-top: 40px;
        display: flex;
        align-items: center;

        .circle {
          display: inline-block;
          width: 1.5rem;
          height: 1.5rem;
          background-color: #fff;
          box-sizing: border-box;
          border-radius: 2rem;
          vertical-align: middle;
        }

        .line {
          display: inline-block;
          width: 14rem;
          transform-origin: center;
          height: 0.2rem;
          background-color: #fff;
          border-radius: 0.6rem;
        }
      }
    }


    // swiper 轮播图
    .sAstyle {
      height: 100%;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      overflow: hidden;
      z-index: 1;
    }

  }

  // 功能区
  .abilityPiece {
    padding: 40px 0;
    height: 150vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    .firstFrame {
      display: flex;
      width: 80%;
      height: 60vh;

      .firstFrame-left {
        width: 35%;

        .firstFrame-leftFrame {
          padding: 62px 0;

          .firstFrame-leftTitle {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 25px;
            letter-spacing: 10px;

            .firstFrame-border {
              padding-top: 10px;
              display: inline-block;
              width: 60%;
              border-bottom: solid 1px;
            }
          }
		  

          .firstFrame-leftText {
            padding-top: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }


      }

      .firstFrame-right {
        width: 35%;
        padding-left: 15px;
		padding-right: 15px;
        .firstFrame-rightFrame {
          padding: 20px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .firstFrame-rightTitle {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 25px;
            letter-spacing: 10px;

            .firstFrame-border {
              padding-top: 10px;
              display: inline-block;
              width: 80%;
              border-bottom: solid 1px;
            }
          }
.firstFrame-rightTitle:hover {
			  cursor: pointer;
		  }
          .firstFrame-rightText {
            padding: 30px;
          }
        }
      }
    }

    .secendFrame {
      padding: 60px 0;
      display: flex;
      width: 80%;
      height: 90vh;
      display: flex;
      justify-content: center;

      .secendFrameText {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 25px;
        letter-spacing: 10px;
        text-decoration: underline;
      }
    }

  }

  // 广告图
  .bigFrame {
    box-sizing: border-box;

    .imgStyle {
      height: auto;
      width: 100%;
    }
  }

}


.footer-box {
  box-sizing: border-box;
  height: 300px;
  width: 100%;
  bottom: 0;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue